import { render, staticRenderFns } from "./ModerationObjectPage.vue?vue&type=template&id=48aacc61"
import script from "./ModerationObjectPage.vue?vue&type=script&lang=js"
export * from "./ModerationObjectPage.vue?vue&type=script&lang=js"
import style0 from "./ModerationObjectPage.vue?vue&type=style&index=0&id=48aacc61&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports